import { render, staticRenderFns } from "./Automations.vue?vue&type=template&id=51654cef&scoped=true&"
import script from "./Automations.vue?vue&type=script&lang=js&"
export * from "./Automations.vue?vue&type=script&lang=js&"
import style0 from "./Automations.vue?vue&type=style&index=0&id=51654cef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51654cef",
  null
  
)

export default component.exports